export default "__VITE_ASSET__BuY0bhwW__"